var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.47053 6.96198L8.03503 0.344074C8.92644 -0.436937 10.3229 0.197807 10.3229 1.38312L10.3229 14.6189C10.3231 14.8842 10.2469 15.1439 10.1033 15.367C9.9597 15.59 9.75487 15.767 9.51331 15.8766C9.27175 15.9863 9.00371 16.024 8.74129 15.9852C8.47886 15.9464 8.23318 15.8328 8.03365 15.658L0.47191 9.04008C0.323698 8.91056 0.204909 8.75084 0.123518 8.57162C0.0421276 8.39241 1.81198e-05 8.19786 1.81198e-05 8.00103C1.81198e-05 7.8042 0.0421276 7.60965 0.123518 7.43044C0.204909 7.25122 0.323698 7.0915 0.47191 6.96198H0.47053Z",
    fill: "#EFC319"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.f68dc684321b3f486d0d2b3db303a156.svg";
export { ForwardRef as ReactComponent };